<template>
    <div class="templete_box">
        <div class="crumbsNav no_print clearfix">
            <div :class="['navSon',tab==1?'navSonChecked':'']" @click="changeTab(1)" v-if="categoryBoardType">
                板材采购入库记录
            </div>
            <div :class="['navSon',tab==2?'navSonChecked':'']" @click="changeTab(2)" v-if="categoryRawType">
                原木采购入库记录
            </div>
        </div>
        <purchaseWarehouseBoard v-if="tab == 1"></purchaseWarehouseBoard>
        <purchaseWarehouseWood v-if="tab == 2"></purchaseWarehouseWood>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                module:localStorage.dw_erp_power_code,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                categoryScrapType:localStorage.dw_erp_category.indexOf("scrap")!=-1?true:false,
                categoryGlulamType:localStorage.dw_erp_category.indexOf("glulam")!=-1?true:false,
                tab : 1
            }
        },
        created(){
        },
        methods:{
            changeTab(tab){
                //this.tab=tab;
                this.$set(this,"tab",tab);
            }
        }
    }
</script>
<style scoped>

</style>